import Footer from "components/organisms/Footer/NoneFooter";
import Header from "components/organisms/Header/InboxHeader";
import Body from "views/MobileViews/Inbox";

const Inbox = () => {

  return (
    <>
    <main style={{overflowX: "hidden", width: "100vw"}}>
      <Header/>
      <Body />
      <Footer />
    </main>
    </>
  );
};

export default Inbox;
